<template>
  <div
    v-if="isInside"
    class="gw_tooltip gw_tooltip_inside csst"
    @click="handleClick()"
    @mouseenter="
      e => {
        fl_positionTooltip(e, { offset: 0, placement: placement })
      }
    "
  >
    <slot name="opener">
      <div
        class="mdi"
        :class="icon"
      ></div>
    </slot>
    <div
      class="csst_content clr-white"
      style="position: fixed; max-width: 34rem"
      :class="tooltipCssClass"
      :style="tooltipCssStyle"
      v-html="tooltip"
    ></div>
  </div>
  <div
    v-else
    ref="cont"
    class="gw_tooltip gw_tooltip_outside csst"
    @click="handleClick"
    @mouseenter="handleMouseenter"
    @mouseleave="handleMouseleave"
  >
    <slot name="opener">
      <div
        class="mdi"
        :class="icon"
      ></div>
    </slot>

    <portal
      v-if="open"
      to="main_before"
    >
      <!-- style="position: fixed; border: solid 1px red" -->
      <div
        ref="tooltip_content"
        class="gw_tooltip_content_outside gw_tooltip_content clr-white anim-fade-in"
        style="position: fixed; max-width: 34rem"
        :class="tooltipCssClass"
        :style="tooltipCssStyle"
        @mouseleave="handleMouseleave"
        v-html="tooltip"
      ></div>
      <slot></slot>
    </portal>
  </div>
</template>

<script>
import float_mix from '@/mixins/float_mix'

export default {
  name: 'GwTooltip',
  mixins: [float_mix],
  props: {
    isInside: Boolean,
    placement: { default: () => 'top' },
    icon: { default: () => 'mdi-help-circle-outline' },
    tooltip: { default: () => '' },
    tooltipCssClass: { default: () => '' },
    tooltipCssStyle: { default: () => '' },
  },
  emits: ['click'],
  data() {
    return {
      open: false,
    }
  },
  methods: {
    handleClick(e) {
      this.$emit('click', e)
    },
    handleMouseleave(e) {
      setTimeout(() => {
        if (e?.toElement?.classList?.contains('gw_tooltip_content_outside')) return
        this.open = false
      })
    },
    handleMouseenter() {
      this.open = true
      requestAnimationFrame(() => {
        if (!this.$refs.cont) return
        if (!this.$refs.tooltip_content) return
        const options = {
          strategy: 'fixed',
          placement: this.placement,
          ...this.flOptions,
        }
        this.fl_setPositionStyle({
          referenceEl: this.$refs.cont,
          element: this.$refs.tooltip_content,
          options,
          boundary: document,
        })
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.gw_tooltip_content_outside {
  z-index: 99;
}
</style>
